import React from 'react';
import { Segmented as AntSegmented } from 'antd';
import type { SegmentedProps as AntSegmentedProps } from 'antd';

import { useAuthDecision } from '../../auth';
import type { AuthProps } from '../../auth';

export type SegmentedProps = AntSegmentedProps & AuthProps;

/**
 * EAA-1804: auth-gated pass-through of antd's `Segmented` — the sheet's
 * single-select view switch (Ma trận / Danh sách / Bảng phủ).
 *
 * Geometry and colors come from the `Segmented` block of `createAntdTheme`
 * (3px track padding, 5px 12px items, radius 8/6), so this wrapper adds only
 * the capability gate. Worth stating explicitly because the sheet is emphatic
 * about one detail the theme encodes: the active item uses the brand teal, NOT
 * a neutral dark fill — a dark fill reads as a disabled/inverted state sitting
 * next to the teal-accented nav.
 *
 * Use for view switches. Multi-select filters are chips, not a segmented.
 */
export function Segmented(props: SegmentedProps): React.ReactElement {
    const { auth, authFallback = 'disable', ...rest } = props;
    const decision = useAuthDecision(auth, authFallback);

    if (decision === 'hide') return <></>;

    return <AntSegmented {...(rest as AntSegmentedProps)} disabled={decision !== 'allow'} />;
}

export default Segmented;
